import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import React from "react";
import FeedbackList from "./FeedbackList";
import { useAppSelector } from "@store/hooks";
import CollapsibleList from "./CollapsibleList";

const name = "DrawerList";

interface DrawerListProps {
    setOpen: any
    setJobId: any
}

const DrawerList: React.FC<DrawerListProps> = ({ setOpen, setJobId }) => {
    const last2 = useAppSelector(({ temp }) => temp.Last2)
    return (
        <Box>
            <CollapsibleList setOpen={setOpen} setJobId={setJobId} />
            <Divider />
            {last2 && last2.some(jr => jr.jobReviews?.score) && <FeedbackList jobReviews={last2} />}
            <Divider />
        </Box >
    )
}

DrawerList.displayName = name;

export default React.memo(DrawerList);